
import ItemCard from '../itemCard/itemCard';
import '../../../style/cityProfitsItemList.scss'



function ItemListContainer(props){
const {listItemsSelected,setItemsSelected} = props
    return (
        <div className="itemList">
        {listItemsSelected.length!==0 ?
        listItemsSelected.map((item)=>(
        <ItemCard key={item.id} canEnchant={item.canEnchant} id={item.id} itemId={item.itemId} itemEnchant={item.itemEnchant} avg={item.avg} itemLocation={item.itemLocation}  setItemsSelected={setItemsSelected} listItemsSelected={listItemsSelected} itemQuality={item.quality}/>
        ))
        : <p className="noItemsSelected">No items have been selected.</p>}
      </div>
    );
}

export default ItemListContainer;
